export class DashboardParamsModel {
  venueGroup;
  venueGroupName;
  timeWindowSelect: {
    timeWindow: string;
    description: string;
  };
  hourSelect: {
    hour;
    day;
    month;
    year;
    description;
  };
  daySelect: {
    monthSelect: {
      month;
      year;
      description;
    };
    dayOfMonth;
    description;
  };
  weekSelect: {
    week;
    year;
    description;
  };
  monthSelect: {
    month;
    year;
    description;
  };
  start;
  startYear;
  startMonth;
  startDay;
  end;
  endYear;
  endMonth;
  endDay;
  description;
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/main/dashboard-params-model.ts